import { useMutation, useQuery } from '@tanstack/react-query'

import {
  deleteInquiry,
  getInquiryCategoryList,
  getInquiryDetail,
  getInquiryList,
  patchInquiry,
  postInquiry,
} from '~/features/inquiry/apis/inquiry'
import {
  type Filters,
  type InquiryRequest,
} from '~/features/inquiry/types/inquiry'

const INQUIRY_KEYS = {
  base: [{ scope: 'inquiry' }] as const,
  category: () => [{ ...INQUIRY_KEYS.base[0], entity: 'category' }] as const,
  list: (filters: Filters) =>
    [{ ...INQUIRY_KEYS.base[0], entity: 'list', filters }] as const,
  detail: (id: string) =>
    [{ ...INQUIRY_KEYS.base[0], entity: 'detail', id }] as const,
}

export const useInquiryCategory = () => {
  return useQuery({
    queryKey: INQUIRY_KEYS.category(),
    queryFn: () => getInquiryCategoryList(),
  })
}

export const useInquiryList = (filters: Filters) => {
  return useQuery({
    queryKey: INQUIRY_KEYS.list(filters),
    queryFn: () => getInquiryList(filters),
  })
}

export const useInquiryDetail = (id: string) => {
  return useQuery({
    queryKey: INQUIRY_KEYS.detail(id),
    queryFn: () => getInquiryDetail(id),
  })
}

export const useInquiryCreate = () => {
  return useMutation({
    mutationFn: (data: InquiryRequest) => postInquiry(data),
  })
}

export const useInquiryUpdate = () => {
  return useMutation({
    mutationFn: (data: InquiryRequest) => patchInquiry(data),
  })
}

export const useInquiryDelete = () => {
  return useMutation({
    mutationFn: (id: string) => deleteInquiry(id),
  })
}
